import CoachingEffectivenessModal from './CoachingEffectivenessModal';

export default CoachingEffectivenessModal;
